// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrolling-tabs .sc-wrapper {
  height: 50px;
  margin: 0 auto;
  padding: 5px;
  position: relative;
  overflow: hidden;
}

.scrolling-tabs .list {
  white-space: nowrap;
  margin-top: 0;
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.scrolling-tabs .list li {
  text-align: center;
  cursor: grab;
  cursor: -webkit-grab;
  vertical-align: middle;
  display: table-cell;
  position: relative;
}

.scrolling-tabs .animate-left {
  transition: left .4s ease-in-out;
}

.scrolling-tabs .scroller {
  padding-left: var(--base-sizes-2);
  padding-right: var(--base-sizes-2);
  padding-top: var(--base-sizes-3);
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  vertical-align: middle;
  background: #ecf0f5;
  border-bottom: 1px solid #ddd;
  padding-bottom: 7px;
  display: none;
}

.scrolling-tabs .scroller.disabled {
  cursor: default;
}

.scrolling-tabs .scroller.disabled i {
  color: #aaa;
}

.scrolling-tabs .scroller:not(.disabled):hover i {
  font-size: 1.2em;
}

.scrolling-tabs .scroller-right {
  float: right;
}

.scrolling-tabs .scroller-left {
  float: left;
}

.scrolling-tabs .white .scroller {
  background: none;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/ScrollingTabs/styles/scrolling-tabs.css","webpack://./services/frontend/app/components/ScrollingTabs/styles/scrolling-tabs.css"],"names":[],"mappings":"AADA;ECEE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;EAClC,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".scrolling-tabs .sc-wrapper {\n    position: relative;\n    margin: 0 auto;\n    overflow: hidden;\n    padding: 5px;\n    height: 50px;\n  }\n  .scrolling-tabs .list {\n    position: absolute;\n    left: 0;\n    top: 0;\n    margin-top: 0;\n    white-space: nowrap;\n    display: flex;\n    right: 0;\n  }\n  .scrolling-tabs .list li {\n    display: table-cell;\n    position: relative;\n    text-align: center;\n    cursor: grab;\n    cursor: -webkit-grab;\n    vertical-align: middle;\n  }\n  .scrolling-tabs .animate-left {\n    transition: left 0.4s ease-in-out;\n  }\n  .scrolling-tabs .scroller {\n    padding-left: var(--base-sizes-2);\n    padding-right: var(--base-sizes-2);\n    padding-top: var(--base-sizes-3);\n\n    text-align: center;\n    cursor: pointer;\n    display: none;\n    padding-bottom: 7px;\n    white-space: nowrap;\n    vertical-align: middle;\n    background: #ecf0f5;\n    border-bottom: 1px solid #ddd;\n}\n  .scrolling-tabs .scroller.disabled {\n      cursor: default;\n    }\n  .scrolling-tabs .scroller.disabled i {\n        color: #aaa;\n      }\n  .scrolling-tabs .scroller:not(.disabled):hover i {\n        font-size: 1.2em;\n      }\n  .scrolling-tabs .scroller-right {\n    float: right;\n  }\n  .scrolling-tabs .scroller-left {\n    float: left;\n  }\n  .scrolling-tabs .white .scroller {\n      background: none;\n    }\n",".scrolling-tabs .sc-wrapper {\n  height: 50px;\n  margin: 0 auto;\n  padding: 5px;\n  position: relative;\n  overflow: hidden;\n}\n\n.scrolling-tabs .list {\n  white-space: nowrap;\n  margin-top: 0;\n  display: flex;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n.scrolling-tabs .list li {\n  text-align: center;\n  cursor: grab;\n  cursor: -webkit-grab;\n  vertical-align: middle;\n  display: table-cell;\n  position: relative;\n}\n\n.scrolling-tabs .animate-left {\n  transition: left .4s ease-in-out;\n}\n\n.scrolling-tabs .scroller {\n  padding-left: var(--base-sizes-2);\n  padding-right: var(--base-sizes-2);\n  padding-top: var(--base-sizes-3);\n  text-align: center;\n  cursor: pointer;\n  white-space: nowrap;\n  vertical-align: middle;\n  background: #ecf0f5;\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 7px;\n  display: none;\n}\n\n.scrolling-tabs .scroller.disabled {\n  cursor: default;\n}\n\n.scrolling-tabs .scroller.disabled i {\n  color: #aaa;\n}\n\n.scrolling-tabs .scroller:not(.disabled):hover i {\n  font-size: 1.2em;\n}\n\n.scrolling-tabs .scroller-right {\n  float: right;\n}\n\n.scrolling-tabs .scroller-left {\n  float: left;\n}\n\n.scrolling-tabs .white .scroller {\n  background: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
